import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { ItemProcessoIndicadorLista } from "../../models/processos_riscos_item_indicador_lista";
import { IGetAllItemProcessoIndicadorUseCase } from "../../../presentation/useCases/read/get_all_qualidade_item_processo_indicador_use_case";
import { ProcessosIndicadorFilter } from "../../models/processos_indicador_filter";

export class GetAllQualidadeItemProcessosIndicadorServicoUseCase
  extends BasePaginatedUseCase<ItemProcessoIndicadorLista>
  implements IGetAllItemProcessoIndicadorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemItemProcessoIndicador(
    filter: ProcessosIndicadorFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemItemProcessoIndicador(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
